module.exports = __webpack_public_path__ + "img/service-float-icon-blanco.ae80989d.png";